import { ICompany } from 'app/shared/model/company.model';

export interface IMaintenanceModel {
  id?: number;
  name?: string | null;
  description?: string | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<IMaintenanceModel> = {};
